<template>
	<div>

		<!------------------------------------------------------
			No Deals Found
		--------------------------------------------------------->
		<div v-if="!isLoading && deals.length < 1">
			no deals found for this search
		</div>
		
		<!------------------------------------------------------
			Deals List
		--------------------------------------------------------->
		<div class="deals-grid">
			<Deal 
				v-if="!isLoading && deals.length > 0"
				v-for="(deal, i) in deals" 
				:key="[i, deal.deal_id].join('')"
				:deal="deal"
			/>
		</div>
	</div>
</template>

<script>
import Deal from './Deal.vue';

//
export default {
	name: "Deals",
	components: {
		Deal
	},
	props: ['isLoading', 'deals'],
	data: function() {
		return {}
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
.loader {
	display: flex;
	justify-content: center;
	text-align: center;
}
</style>